import { Modal, Descriptions, Tag, Divider, List } from 'antd';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { t } from '../../i18n/i18n';
import { getStatusConfig, calculateDuration } from '../../utils/workflowExecutionUtils';

const ExecutionDetailModal = ({ visible, onCancel, execution }) => {
  const formatDate = (date) => {
    if (!date) return '-';
    try {
      return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: es });
    } catch {
      return '-';
    }
  };

  return (
    <Modal
      title={t('ALKYMATION_EXECUTION_DETAIL')}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
      className="execution-detail-modal"
    >
      {execution && (
        <>
          <Descriptions bordered size="small" column={2}>
            <Descriptions.Item label={t('ALKYMATION_EXECUTION_ID')} span={2}>
              <code>{execution.executionId}</code>
            </Descriptions.Item>
            <Descriptions.Item label={t('ALKYMATION_WORKFLOW_ID')} span={2}>
              <code>{execution.workflowId}</code>
            </Descriptions.Item>
            <Descriptions.Item label={t('ALKYMATION_STATUS')} span={2}>
              <Tag
                color={getStatusConfig(execution.status).color}
                icon={getStatusConfig(execution.status).icon}
                className="d-flex align-items-center"
              >
                {getStatusConfig(execution.status).text}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label={t('ALKYMATION_START_DATE_TIME')}>
              {formatDate(execution.startedAt)}
            </Descriptions.Item>
            <Descriptions.Item label={t('ALKYMATION_END_DATE_TIME')}>
              {execution.completedAt
                ? formatDate(execution.completedAt)
                : t('ALKYMATION_IN_PROGRESS')}
            </Descriptions.Item>
            <Descriptions.Item label={t('ALKYMATION_DURATION')} span={2}>
              {calculateDuration(execution.startedAt, execution.completedAt) ||
                t('ALKYMATION_IN_PROGRESS')}
            </Descriptions.Item>
          </Descriptions>

          {execution.nodeExecutions && execution.nodeExecutions.length > 0 && (
            <>
              <Divider>
                {t('ALKYMATION_EXECUTED_NODES')} ({execution.nodeExecutions.length})
              </Divider>
              <List
                size="small"
                dataSource={execution.nodeExecutions}
                renderItem={(node) => (
                  <List.Item>
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <span>
                          <Tag color={getStatusConfig(node.status).color} size="small">
                            {getStatusConfig(node.status).text}
                          </Tag>
                          <strong>{t(node.nodeName)}</strong>
                        </span>
                        <span className="text-muted small">
                          {calculateDuration(node.startedAt, node.completedAt) || '-'}
                        </span>
                      </div>
                      {node.error && (
                        <div className="node-error text-danger mt-1">
                          {t('ALKYMATION_ERROR')}: {node.error}
                        </div>
                      )}
                    </div>
                  </List.Item>
                )}
              />
            </>
          )}

          {execution.errors && execution.errors.length > 0 && (
            <>
              <Divider>{t('ALKYMATION_ERRORS')}</Divider>
              {execution.errors.map((error, index) => (
                <div key={index} className="error-alert alert alert-danger">
                  <strong>
                    {t('ALKYMATION_NODE')} {error.nodeId}:
                  </strong>{' '}
                  {error.message}
                  <div className="error-timestamp text-muted">{formatDate(error.timestamp)}</div>
                </div>
              ))}
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default ExecutionDetailModal;
